/**
 * The locale the page is SHOWING (`<html lang>`, set by `LocaleProvider`),
 * sent with a request that makes the server write to somebody it may not know
 * yet — a sign-in code, a phone code, a password reset (step 73.8). The server
 * uses it only when the account has no locale of its own. `{}` when the page
 * has none (a test, a bare shell).
 */
export function shownLocaleHint(): { locale?: string } {
  const lang = typeof document === 'undefined' ? '' : document.documentElement.getAttribute('lang') ?? '';
  return /^[a-z]{2,3}-[A-Z]{2}$/.test(lang) ? { locale: lang } : {};
}

/**
 * The header every API request carries (2026-10-27, the user: "the languages
 * should be applied … everywhere"): the locale the page is SHOWING, so what
 * the API answers in words — a refusal's message, a ride's status — is in the
 * reader's language. Not `Accept-Language`: the device's language is only the
 * default (2026-10-28) — a language picked in the app wins, and the answer must match the page. `{}` when the page shows none.
 */
export function localeHeader(): Record<string, string> {
  const { locale } = shownLocaleHint();
  return locale ? { 'x-myrave-locale': locale } : {};
}
